<template>
    <lv-base-column
            ref="column" v-bind="columnBinding">
        <template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
            <link-table-column-timepicker-item
                    :row="row"
                    :edit-row="editRow"
                    :row-index="rowIndex"
                    :col="col"
                    :col-index="colIndex"
                    :fixed-row="fixedRow"
                    v-bind="columnItemBinding"
                    @click="lv_clickItem"

                    :display-format="displayFormat"
                    :value-format="valueFormat"
            />
        </template>
    </lv-base-column>
</template>

<script>
    import {ColumnMixin} from "../mixins";
    import LinkTableColumnTimepickerItem from "./link-table-column-timepicker-item";
    import LvBaseColumn from "../../table/lv-base-column";

    export default {
        name: 'link-table-column-timepicker',
        components: {LvBaseColumn, LinkTableColumnTimepickerItem},
        mixins: [ColumnMixin,],
        props: {
            filterName: {default: 'date'},
            width: {default: 80},

            value: {type: String},
            displayFormat: {type: String, default: 'HH:mm:ss'},
            valueFormat: {type: String, default: 'HH:mm:ss'},
            noInput: {type: Boolean, default: false},
            hideOnClickOutSide: {type: Boolean, default: true},
            direction: {default: 'bottom'},
            align: {default: 'start'},
            show: {type: Boolean, default: false},
            type: {type: String, default: 'line',},
            color: {type: String, default: 'info',},
            size: {type: String, default: 'default',},
            shape: {type: String, default: 'none',},
            dashed: {type: Boolean,},
            long: {type: Boolean,},
            prefixIcon: {type: String},
            suffixIcon: {type: String, default: 'link-icon-time-circle'},
            placeholder: {type: String, default: '点击输入内容'},
            disabled: {type: Boolean},
            readonly: {type: Boolean},
            clearable: {type: Boolean},
            regexp: {type: RegExp},

            formatter: {
                default() {
                    return (val) => {
                        return !!val ? this.$lv.$utils.dateFormat(this.$lv.$utils.dateParse(val, this.valueFormat), this.displayFormat) : null
                    }
                },
            },
        },
    };
</script>
